const fonts = [
  '"Madimi One", sans-serif',
  '"Schoolbell", cursive',
  '"Nixie One", system-ui',
  '"Mochiy Pop One", sans-serif',
  '"Yesteryear", cursive',
  '"Knewave", system-ui',
  '"Klee One", cursive',
  '"Ojuju", sans-serif',
  '"Encode Sans Expanded", sans-serif',
  '"Boogaloo", sans-serif',
  '"Calligraffitti", cursive',
  '"Averia Libre", system-ui',
  '"Coming Soon", cursive',
  '"Grandstander", cursive',
  '"Short Stack", cursive',
  '"Inknut Antiqua", serif',
  '"Rozha One", serif',
  '"Mali", cursive',
  '"Seaweed Script", cursive',
  '"Rancho", cursive',
  '"Nanum Brush Script", cursive',
  '"Aclonica", sans-serif',
  '"Just Another Hand", cursive',
  '"Cedarville Cursive", cursive',
  '"Herr Von Muellerhoff", cursive',
  '"Reddit Mono", monospace',
  '"Shadows Into Light Two", cursive',
  '"BioRhyme", serif',
  '"Belleza", sans-serif',
  '"Cinzel Decorative", serif',
  '"Sofia Sans", sans-serif',
  '"Rubik Moonrocks", sans-serif',
  '"Black And White Picture", system-ui',
  '"Cabin Sketch", sans-serif',
  '"Chewy", system-ui',
  '"Cutive Mono", monospace',
  '"Rammetto One", sans-serif',
  '"Jersey 25", sans-serif',
  '"Gochi Hand", cursive',
  '"Quantico", sans-serif',
  '"Chivo Mono", monospace',
  '"Luckiest Guy", cursive',
  '"Gloria Hallelujah", cursive',
  '"Kalam", cursive',
  '"Pacifico", cursive',
  '"Dancing Script", cursive',
  '"Bebas Neue", sans-serif',
  '"Margarine", sans-serif',
  '"Quicksand", sans-serif',
  '"Merriweather", serif',
  '"PT Sans", sans-serif',
  '"Playwrite AR", cursive',
  '"Playwrite CL", cursive',
  '"Playwrite HR Lijeva", cursive',
  '"Playwrite HU", cursive',
  '"Playwrite PE", cursive',
  '"Ubuntu", sans-serif',
  '"Noto Sans", sans-serif',
  '"Arsenal SC", sans-serif',
  '"Oswald", sans-serif',
  '"Roboto Condensed", sans-serif',
  '"Anton SC", sans-serif',
  '"Inter", sans-serif',
  '"Lato", sans-serif',
  '"Poppins", sans-serif',
  '"Montserrat", sans-serif',
  '"Bodoni Moda SC", serif',
  '"Open Sans", sans-serif',
  '"Ga Maamli", sans-serif',
  '"Wittgenstein", serif',
  '"Baskervville SC", serif',
  '"Roboto", sans-serif',
];

export default fonts;
